import {NutrientType} from "@/models/Ingredient/NutrientType";

export enum OrderType {
    Asc, Desc,
}

export interface Ordering {
    field: string;
    orderType: OrderType;
}

export interface Filter {
    name: string;
    value: string;
}

export interface ListRequestOptions {
    page?: number;
    pageSize?: number;
    filters?: Filter[];
    orders?: Ordering[];
    searchTerm?: string;

}

export default class ListRequest {
  public queryOptions: ListRequestOptions;
  public restaurantId?: number;
  public nutrientTypesToCalculate?: NutrientType[];

  constructor(
    listRequestOptions: ListRequestOptions,
    restaurantId?: number,
    nutrientTypesToCalculate: NutrientType[] = null
  ) {
    this.queryOptions = listRequestOptions;
    this.restaurantId = restaurantId;
    this.nutrientTypesToCalculate = nutrientTypesToCalculate;
  }
}
